import { asMenuItem, MenuItem } from "../components/menu";
import {
  openInstallSheet,
  promptInstall,
  useInstall,
} from "./install/install-state";

const ICON = { ios: "f7:arrow_down_to_line", md: "material:install_mobile" };

const noop = () => {};

const DownloadAppButton = asMenuItem(({ onOpen = noop }) => {
  const { method } = useInstall();

  if (!method) return null;

  const install = () => {
    onOpen();
    if (method === "ios") openInstallSheet();
    else promptInstall();
  };

  return (
    <MenuItem
      className="download-app"
      title="App installieren"
      icon={ICON}
      tone="teal"
      onClick={install}
    />
  );
});

export default DownloadAppButton;
